import {defaultIO} from "../../DefaultIO";
import {PlaceSummaryValueObject} from "../../../model/vo/content/place/stats/PlaceSummaryValueObject";
import {PlaceFunnelAnalyticsValueObject} from "../../../model/vo/content/place/stats/PlaceFunnelAnalyticsValueObject";
import {
    PlaceSummaryFunnelStatsDataTransferObject
} from "../../../model/dto/content/place/stats/PlaceSummaryFunnelStatsDataTransferObject";


export const PlaceFunnelIO = {
    postFunnelRecord(dto:PlaceSummaryFunnelStatsDataTransferObject.Post){
        return defaultIO('/api/v3/contents/places/summaries/records'
            ,PlaceSummaryFunnelStatsDataTransferObject.Post.construct)
            .post(dto)
    },

    listFunnelStatsPerPlace(){
        return defaultIO('/api/v3/contents/places/summaries/records'
            , PlaceFunnelAnalyticsValueObject.Stats.construct).list
    },

    listFunnelStatsGroupedByExposedAt(){
        return defaultIO('/api/v3/contents/places/summaries/records/stats'
            , PlaceFunnelAnalyticsValueObject.TotalStats.construct).list
    },

    countFunnelStatsPerPlace(){
        return defaultIO('/api/v3/contents/places/summaries/records/count'
            , PlaceFunnelAnalyticsValueObject.Stats.construct).count
    },

    countFunnelStatsGroupedByExposedAt(){
        return defaultIO('/api/v3/contents/places/summaries/records/stats/count'
            , PlaceFunnelAnalyticsValueObject.TotalStats.construct).count
    }

}